<template>
  <div class="container">
    <form novalidate @submit.prevent="checkLocalId">
      <HeadingOne class="-margin-md">ログインID設定</HeadingOne>

      <ErrorsAlert :errors="errors" :items="inputItemsCe"></ErrorsAlert>

      <WizardGroup class="-margin-md">
        <MainWizard :active-index="0" type="localid"></MainWizard>
      </WizardGroup>

      <p>
        ご本人さま確認のため、ご登録いただいたお客さま情報と秘密のことばの答えを入力してください。
      </p>

      <section>
        <TableGroup>
          <TableBox>
            <TableBody>
              <TableRow>
                <TableHeader class="-entry"
                  >氏名<small
                    >（フリガナ）<small class="moji">【全角カナ】</small></small
                  ></TableHeader
                >
                <TableData :has-error="errors['name_kana']">
                  <InputgroupAppend class="name-box _mb-15">
                    <InputGroup
                      class="name"
                      :errors="errors"
                      :prop-names="['name_kana']"
                    >
                      <div class="input-box _pr-sm-10 _mr-md-40">
                        <InputItem
                          id="lastname_kanji"
                          v-model="localIdData.lastname_kana"
                          class="-sm"
                          :maxlength="20"
                        ></InputItem>
                        <InputLabel id="lastname_kanji">
                          例：エイユウ
                        </InputLabel>
                      </div>
                      <div class="input-box _pl-sm-10">
                        <InputItem
                          id="lastname_kanji"
                          v-model="localIdData.firstname_kana"
                          class="-sm"
                          :maxlength="20"
                        ></InputItem>
                        <InputLabel id="lastname_kanji">
                          例：タロウ
                        </InputLabel>
                      </div>
                    </InputGroup>
                  </InputgroupAppend>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader class="-entry"
                  >生年月日<small class="moji">【半角数字】</small></TableHeader
                >
                <TableData :has-error="errors['birtyday']">
                  <InputGroup :errors="errors" :prop-names="['birtyday']">
                    <InputgroupAppend>
                      <InputItem
                        id=""
                        v-model="localIdData.birtyday"
                        type="text"
                        class="-md"
                        :maxlength="8"
                      ></InputItem>
                    </InputgroupAppend>
                    <InputLabel id="">
                      入力例：1988年1月1日 → 19880101
                    </InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader class="-entry"
                  >秘密のことば<small>（質問）</small></TableHeader
                >
                <TableData :has-error="errors['secret_word_ask']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['secret_word_ask']"
                  >
                    <BtnSelect
                      id="secret_word_ask"
                      v-model="localIdData.secret_word_ask"
                      class="form-control"
                    >
                      <option
                        v-for="(secretWordAsk, index) in secretWordAsks"
                        :key="'secretWordAsk1' + index + 1"
                        :value="secretWordAsk['value']"
                      >
                        {{ secretWordAsk["name"] }}
                      </option>
                    </BtnSelect>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader class="-entry"
                  >秘密のことば<small
                    >（答え）<small class="moji"
                      >【全角ひらがな、30文字以内】</small
                    ></small
                  ></TableHeader
                >
                <TableData :has-error="errors['secret_word_ans']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['secret_word_ans']"
                  >
                    <InputgroupAppend>
                      <InputItem
                        id="secret_word_ans"
                        v-model="localIdData.secret_word_ans"
                        class="-lg"
                        :maxlength="30"
                      ></InputItem>
                    </InputgroupAppend>
                  </InputGroup>
                </TableData>
              </TableRow>
            </TableBody>
          </TableBox>
        </TableGroup>
      </section>

      <ListGroup class="-link">
        <ListItem
          class="-link"
          router-name="sv036"
          hash="#section_01"
          target="_blank"
        >
          秘密のことばを忘れた方はこちら
        </ListItem>
      </ListGroup>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-main" @click.prevent="checkLocalId"> 次へ </BtnMain>
      </BtngroupSingle>
    </form>
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import { initCredentials } from "@/utils/Auth";
import { localIdUserCheck } from "@/utils/LocalLoginHelper";
import { secretWordAsks, inputItemsCe } from "@/constants/constant";
import { goToErrorPage, scrollTop } from "@/utils/Other";
import HeadingOne from "@/components/heading/HeadingOne";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import InputGroup from "@/components/input/InputGroup";
import InputItem from "@/components/input/InputItem";
import InputgroupAppend from "@/components/input/InputgroupAppend";
import InputLabel from "@/components/input/InputLabel";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtnSelect from "@/components/button/BtnSelect";
import ErrorsAlert from "@/components/alert/ErrorsAlert";

export default {
  name: "Ce003",
  components: {
    ErrorsAlert,
    BtnSelect,
    ListItem,
    ListGroup,
    BtnMain,
    BtngroupSingle,
    InputLabel,
    InputgroupAppend,
    InputItem,
    InputGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    WizardGroup,
    MainWizard,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "ログインID設定",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,ローカルID,認証方法",
    });
  },
  data() {
    return {
      errors: {},
      isDisabled: false,
      secretWordAsks: secretWordAsks,
      localIdData: {
        lastname_kana: "",
        firstname_kana: "",
        birtyday: "",
        secret_word_ask: "00",
        secret_word_ans: "",
      },
      inputItemsCe: inputItemsCe,
    };
  },
  mounted() {
    localStorage.removeItem("local_login_data");
    localStorage.removeItem("local_id_data");
  },
  methods: {
    checkLocalId() {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        initCredentials()
          .then(() => {
            localIdUserCheck(this.localIdData)
              .then((res) => {
                if (res.result.check === "OK") {
                  this.localIdData["account_id"] =
                    res.result.api_result.account_id;
                  localStorage.setItem(
                    "local_id_data",
                    JSON.stringify(this.localIdData)
                  );
                  this.$router.push({ name: "ce006" });
                } else {
                  if (
                    Object.prototype.hasOwnProperty.call(
                      res.result,
                      "api_result"
                    ) &&
                    res.result.api_result.status === "2"
                  ) {
                    this.$router.push({ name: "er005" });
                  }
                  this.errors = res.result.error || {};
                  scrollTop();
                  this.isDisabled = false;
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.input-double {
  @include mq-up(md) {
    display: flex;
    width: 100%;
  }
  .input-group {
    &.-input {
      width: 30%;
      display: inline;
    }
  }
}
.table-data {
  > .inputgroup-append {
    &.name-box {
      align-items: flex-end;
      .input-group {
        &.name {
          display: flex;
          flex-wrap: wrap;
          .input-box {
            @include mq-down(md) {
              max-width: 50%;
              width: 100%;
            }
          }
        }
      }
    }
  }
  &.name-box {
    @include flex(flex, flex-start, center, row, wrap);
    width: 100%;
    border: none;
    @include mq-down(md) {
      align-items: flex-start;
      justify-content: space-between;
    }
    .warning {
      width: 100%;
    }
    .input-group {
      @include mq-down() {
        width: 50%;
        &:first-child {
          padding-right: 10px;
        }
      }
      &.name {
        @include mq-down(md) {
          margin-bottom: 15px;
        }
        @include mq-up(md) {
          /*max-width: 30%;*/
          /*width: 100%;*/
        }
      }
      .input-item {
        @include mq-down(md) {
          max-width: 130px;
          width: 100%;
        }
      }
      .input-append {
        min-width: 48px;
      }
    }
  }
}
</style>
